import { AppBar, Box, IconButton, Toolbar, Typography } from "@mui/material";
import React from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Link } from "react-router-dom";

const AppLayoutSecondaryHeader = (props) => {
  return (
    <AppBar
      position="fixed"
      //sx={{ top: 50, zIndex: (theme) => theme.zIndex.drawer }}
      sx={{ top: 50, zIndex: 1000 }}
    >
      <Toolbar>
        {props.backTo && (
          <Link to={props.backTo}>
            <IconButton
              size="large"
              edge="start"
              sx={{ color: "#fff" }}
              aria-label="menu"
            >
              <KeyboardBackspaceIcon />
            </IconButton>
          </Link>
        )}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {props.title || ""}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {props.children}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
export default AppLayoutSecondaryHeader;
